// extracted by mini-css-extract-plugin
module.exports = {"left":"two-column-module--left--1L1Cn","right":"two-column-module--right--1MwX-"};